import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertIssueUpdateMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertIssueUpdateDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertIssueUpdateInput = {
  ParentIssueId: string;
  Title: string;
  Description: string;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertIssueUpdate = createMutationHook({
  name: 'insertIssueUpdate',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.issueUpdate.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (input: InsertIssueUpdateInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.issueUpdate.getById.queryKey(),
    // COI-889: parity with the update and delete siblings.
    trpc.frontend.issueUpdate.register.queryKey(),
    // COI-889: the Issues register's latest-update and update-count columns
    // read `issueUpdateSummary`.
    trpc.frontend.issue.register.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertIssueUpdateMutation => ({
    insert_issue_update_one: {
      __typename: 'issue_update',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertIssueUpdateDocument,
  graphqlVariables: (input: InsertIssueUpdateInput) => ({ ...input }),
});
